<template>
  <div>
  
    <div class="tiemOUts">观测时间{{times}}</div>           
        <el-table :data="tableDatainfo" max-height="430" border  :row-class-name="tableRowClassName">
      <el-table-column label="通道号" align="center"  >
        <template slot-scope="scope">{{scope.row.channelid}}</template>
      </el-table-column>
      <el-table-column label="要素"  align="center">
        <template
          slot-scope="scope"
        >{{ lang_file == 'zh-cn'? scope.row.unittype : scope.row.unittype_en}}</template>
      </el-table-column>
      <el-table-column label="数值"  align="center">
        <template slot-scope="scope">
          {{scope.row.channeldata}}
          <!-- <el-tag type="success">{{scope.row.channeldata}}</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column label="单位" align="center">
        <template slot-scope="scope">
          <!-- <el-tag effect="plain"></el-tag> -->
          {{scope.row.unit}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {times} from "@/components/common/time";
export default {
  props: {
   tableDatainfo:{
     type:Array
   }
  },
  data() {
    return {
        lang_file:'',
        times:''
    };
  },
  created() {},
  mounted() {
    this.lang_file = sessionStorage.getItem("lang_file")
    this.times = times
    
  },
  methods: {
    tableRowClassName({ row, rowIndex }){
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    }
  }
};
</script>

<style scoped >

.times {
  width: 40%;
  display: flex;
  padding: 0 10px 0 0px;
  justify-content: space-between;
}
</style>
